module.exports = __webpack_public_path__ + "static/media/trigo_creales.066bb27a.png";